import { FC, ReactElement, ReactNode } from 'react';
import { topListColors } from '~/constants/styles';
import './style.scss';

interface IProps {
  index: number;
  firstColumn: ReactNode;
  secondColumn: ReactNode;
}

const DashboardDetailsCrumbsRow: FC<IProps> = ({ index, firstColumn, secondColumn }: IProps): ReactElement => {
  return (
    <div className="dashboard-details-crumbs-row dashboard-details-crumbs-row__grid-template">
      <div className="d-flex flex-row align-items-center">
        <div className="dashboard-details-crumbs-row__color mr-4" style={{ background: topListColors[index + 1] }} />
        {firstColumn}
      </div>

      {secondColumn}
    </div>
  );
};

export default DashboardDetailsCrumbsRow;
